<template>
  <div>
    <Header />
    <Drawer />
    <div v-if="authState !== 'signedin' && isGuestMode">
      <slot />
    </div>
    <div v-if="!isGuestMode">
      <amplify-authenticator>
        <amplify-sign-in slot="sign-in" hide-sign-up="true"></amplify-sign-in>
        <slot />
      </amplify-authenticator>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from './Header'
import Drawer from './navigation/Drawer'

export default {
  name: 'Authenticator',
  components: { Header, Drawer },
  computed: {
    ...mapState({
      isGuestMode: (state) => state.isGuestMode,
      authState: (state) => state.authState
    })
  },
  methods: {
    toggleGuestMode() {
      this.$store.commit("setGuestMode", !this.isGuestMode);
    },
  }
}
</script>
